import { createSaga } from './saga-helpers';

import * as Api from '../api/subscriptions-api';

const watchSubscribe = createSaga({
    type: 'SUBSCRIBE',
    fn: Api.subscribe,
    args: action => [action.payload.association, action.payload.association_id],
    errorPayload: (e, action) => ({
        message: e.message || e,
        association_id: action.payload.association_id,
    })
});

const watchUnsubscribe = createSaga({
    type: 'UNSUBSCRIBE',
    fn: Api.unsubscribe,
    args: action => [action.payload.association, action.payload.association_id],
    errorPayload: (e, action) => ({
        message: e.message || e,
        association_id: action.payload.association_id,
    })
});

export default [watchSubscribe, watchUnsubscribe];
